/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RefundsContainer_viewer$ref: FragmentReference;
export type RefundsContainer_viewer = {|
  +s_time_zone: ?string,
  +refunds: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +amount_cents: ?number,
        +amount_currency: ?string,
        +refunded_at: ?any,
        +payment: ?({|
          +__typename: "CustomPayment",
          +label: ?string,
        |} | {|
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          +__typename: "%other"
        |}),
        +invoice: ?{|
          +id: string,
          +title: ?string,
          +workspaces: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +event: ?{|
                  +title: ?string
                |}
              |}
            |}>
          |},
        |},
      |}
    |}>,
    +pageInfo: {|
      +endCursor: ?string,
      +hasNextPage: boolean,
    |},
  |},
  +$refType: RefundsContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "RefundsContainer_viewer",
  "type": "User",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "refunds"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "refunds_after",
      "type": "ISO8601Type",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "refunds_before",
      "type": "ISO8601Type",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "refunds",
      "name": "__Refunds_refunds_connection",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after_time",
          "variableName": "refunds_after",
          "type": "ISO8601Type"
        },
        {
          "kind": "Variable",
          "name": "before_time",
          "variableName": "refunds_before",
          "type": "ISO8601Type"
        }
      ],
      "concreteType": "RefundConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "RefundEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Refund",
              "plural": false,
              "selections": [
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount_cents",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount_currency",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "refunded_at",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "payment",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [
                    v1,
                    {
                      "kind": "InlineFragment",
                      "type": "CustomPayment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "label",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "invoice",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Invoice",
                  "plural": false,
                  "selections": [
                    v0,
                    v2,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "workspaces",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "WorkspaceConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "WorkspaceEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Workspace",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "event",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "Event",
                                  "plural": false,
                                  "selections": [
                                    v2
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                v1
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '772404aa7324926d68e5fa324ec6b49a';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Financial/Payments/__generated__/RefundsContainer_viewer.graphql.js